import { SxProps } from "@mui/material"

export const sxButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    padding: '12px 32px ',
    height: '100%'
}

export const sxOutlinedButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    border: '2px solid var(--Primary-01-Medium, #00995D)',
    padding: '12px 32px ',
    color: 'rgb(0,0,0,0.08)',
    '&:focus': {
        background: '#fff'
    }
}

export const sxOutlinedButtonAccessibility: SxProps = {
    ...sxOutlinedButton,
    border: '2px solid #FFFF00',
    color: '#FFFF00'
}

export const sxCheckbox: SxProps = {
    '.MuiFormControlLabel-label': {
        fontSize: '14px',
        color: '#4C4C4C'
    } 
}

export const sxFeatureCard: SxProps = {
    borderRadius: '10px',
    backgroundColor: '#FFF',
    boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08)',
    color: 'rgba(0, 0, 0, 0.08)',
    width: '100%',
    height: '120px',
    padding: '24px',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '24px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    textTransform: 'none',
    '&:hover': {
        boxShadow: '0px 4px 50px 0px',
        backgroundColor: '#FFF',
        cursor: 'pointer'
    },

    'svg': {
        color:' #00995D'
    }
}

export const sxButtonAccessibility: SxProps = {
    ...sxButton,
    borderColor: '#FFFF00',
    color: '#FFFF00'
}